export default "__VITE_ASSET__DhiKtn2C__"